import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.turnkeyOmnibus, action) => {
  switch (action.type) {
    case types.RESET_IE_STATE: {
      return {
        ...state,
        ...initialState.turnkeyOmnibus,
        navFlow: action.navFlow,
      };
    }
    case types.SET_IE_ACTIVE_STEP: {
      return {
        ...state,
        activeStep: action.step,
      };
    }
    case types.IE_STUDIES_REQUEST: {
      return {
        ...state,
        ieStudy: {
          loading: true,
          error: false,
          data: [],
        },
      };
    }
    case types.IE_STUDIES_SUCCESS: {
      return {
        ...state,
        ieStudy: {
          loading: false,
          error: false,
          data: action.studies,
        },
      };
    }
    case types.IE_STUDIES_FAILURE: {
      return {
        ...state,
        ieStudy: {
          loading: false,
          error: true,
          data: [],
        },
      };
    }
    case types.IE_SURVEY_LIST_REQUEST: {
      return {
        ...state,
        ieSurveyList: {
          loading: true,
          error: false,
          data: [],
        },
      };
    }
    case types.IE_SURVEY_LIST_SUCCESS: {
      return {
        ...state,
        ieSurveyList: {
          loading: false,
          error: false,
          data: action.surveyList,
        },
      };
    }
    case types.IE_SURVEY_LIST_FAILURE: {
      return {
        ...state,
        ieSurveyList: {
          loading: false,
          error: true,
          data: [],
        },
      };
    }

    case types.SET_IE_SURVEY_DETAILS: {
      return {
        ...state,
        surveyDetails: {
          data: action.survey,
        },
      };
    }

    case types.SET_IE_SURVEY_NAME: {
      return {
        ...state,
        surveyInfo: {
          ...state.surveyInfo,
          surveyName: action.surveyName,
        },
      };
    }

    case types.SET_IE_CATEGORIES_REQUEST: {
      return {
        ...state,
        ieCategories: {
          loading: true,
          error: false,
          data: [],
        },
      };
    }
    case types.SET_IE_CATEGORIES_SUCCESS: {
      return {
        ...state,
        ieCategories: {
          loading: false,
          error: false,
          data: action.categories,
        },
      };
    }
    case types.SET_IE_CATEGORIES_FAILURE: {
      return {
        ...state,
        ieCategories: {
          loading: false,
          error: true,
          data: [],
        },
      };
    }

    case types.SET_IE_SURVEY_INFO: {
      return {
        ...state,
        surveyInfo: {
          ...state.surveyInfo,
          ...action.info,
        },
      };
    }

    case types.IE_TARGET_REQUEST: {
      return {
        ...state,
        targetingCriteria: {
          loading: true,
          error: false,
          sti: null,
          data: [],
        },
      };
    }

    case types.IE_PRODEGE_MAPPING_SUCCESS: {
      return {
        ...state,
        prodegeKeywords: action.keywords,
      };
    }

    case types.IE_KEYWORDS_SUCCESS: {
      return {
        ...state,
        keywords: action.keywords,
      };
    }

    case types.IE_TARGET_SUCCESS: {
      return {
        ...state,
        targetingCriteria: {
          loading: false,
          error: false,
          data: action.tc,
          sti: action.sti,
        },
      };
    }

    case types.IE_TARGET_FAILURE: {
      return {
        ...state,
        targetingCriteria: {
          loading: false,
          error: true,
          sti: null,
          data: [],
        },
      };
    }

    case types.SET_IE_SELECTED_TARGETS: {
      return {
        ...state,
        selectedTargets: action.selectedTargets,
      };
    }

    case types.IE_EDIT_SURVEY: {
      return {
        ...state,
        isEdit: action.state,
      };
    }

    case types.IE_EDIT_SURVEY_REQUEST: {
      return {
        ...state,
        ieSurvey: {
          loading: true,
          error: false,
          data: null,
        },
      };
    }

    case types.IE_EDIT_SURVEY_SUCCESS: {
      return {
        ...state,
        ieSurvey: {
          loading: false,
          error: false,
          data: action.data,
        },
      };
    }

    case types.IE_EDIT_SURVEY_FAILURE: {
      return {
        ...state,
        ieSurvey: {
          loading: false,
          error: true,
          data: null,
        },
      };
    }

    case types.RESET_IE_SURVEY_INFO: {
      return {
        ...state,
        surveyInfo: initialState.turnkeyOmnibus.surveyInfo,
      };
    }

    case types.SET_IE_SAMPLE_WGTD: {
      return {
        ...state,
        samplewgtd: action.data,
      };
    }

    case types.SET_IE_COMPLETES: {
      return {
        ...state,
        completesEstimate: action.completes,
      };
    }

    case types.SET_IE_CROSSTAB: {
      return {
        ...state,
        crossTabIR: action.data,
      };
    }

    case types.GET_IE_IR_SS_REQUEST: {
      return {
        ...state,
        ir_ss_data: {
          loading: true,
          error: false,
        },
      };
    }

    case types.GET_IE_IR_SS_SUCCESS: {
      return {
        ...state,
        ir_ss_data: {
          loading: false,
          error: false,
        },
      };
    }

    case types.GET_IE_IR_SS_FAILURE: {
      return {
        ...state,
        ir_ss_data: {
          loading: false,
          error: false,
        },
      };
    }

    case types.IE_CREATE_SURVEY_REQUEST: {
      return {
        ...state,
        savingSurvey: {
          loading: true,
          error: false,
        },
      };
    }
    case types.IE_CREATE_SURVEY_SUCCESS: {
      return {
        ...state,
        savingSurvey: {
          loading: false,
          error: false,
        },
      };
    }
    case types.IE_CREATE_SURVEY_FAILURE: {
      return {
        ...state,
        savingSurvey: {
          loading: false,
          error: true,
        },
      };
    }

    case types.IE_SURVEY_METADATA_REQUEST: {
      return {
        ...state,
        surveyQnO: {
          ...state.surveyQnO,
          ...initialState.turnkeyOmnibus.surveyQnO,
        },
      };
    }

    case types.IE_SURVEY_METADATA_SUCCESS: {
      return {
        ...state,
        surveyQnO: {
          ...state.surveyQnO,
          metaData: action.metaData,
        },
      };
    }

    case types.IE_SURVEY_METADATA_QO: {
      return {
        ...state,
        surveyQnO: {
          ...state.surveyQnO,
          loading: false,
          error: false,
          data: {
            questions: action.questions,
            options: action.options,
          },
        },
      };
    }

    case types.IE_SURVEY_METADATA_FAILURE: {
      return {
        ...state,
        surveyQnO: {
          ...state.surveyQnO,
          ...initialState.turnkeyOmnibus.surveyQnO,
          loading: false,
          error: true,
        },
      };
    }

    case types.SET_IE_SURVEY_DICTIONARY: {
      return {
        ...state,
        surveyQnO: {
          ...state.surveyQnO,
          dictionary: action.dictionary,
        },
      };
    }

    case types.SET_IE_SURVEY_DICTIONARY_ERROR: {
      return {
        ...state,
        surveyQnO: {
          ...state.surveyQnO,
          invalid: {
            specialChar: action.specialChar,
            maxLength: action.maxLength,
          },
        },
      };
    }

    case types.SET_IE_SURVEY_DICTIONARY_TEXT: {
      return {
        ...state,
        surveyQnO: {
          ...state.surveyQnO,
          updatedQnO: {
            questions: action.questions,
            options: action.options,
          },
        },
      };
    }

    default:
      return state;
  }
}
